import { GET } from "utils/fetcher";
export const FETCH_STATS_CHECKPOINT_BEGIN = "FETCH_STATS_CHECKPOINT_BEGIN";
export const FETCH_STATS_CHECKPOINT_SUCCESS = "FETCH_STATS_CHECKPOINT_SUCCESS";
export const FETCH_STATS_CHECKPOINT_FAILURE = "FETCH_STATS_CHECKPOINT_FAILURE";
export const CLEAR_STATS_CHECKPOINTS = "CLEAR_STATS_CHECKPOINTS";
export const SET_MANUAL_COUNTS = "SET_MANUAL_COUNTS";

/**
 * Retrieve the count from manualCount for one checkpoint
 * @param  {Object} statsCheckpoint - The object that contain in/decrement
 * @param  {Strin|Number} id - CheckpointId
 * @return {Number} - The result of the in/decrement
 */
export const getCountFromState = (
	{ statsCheckpoint: { manualCounts } },
	id
) => {
	if (!id || !manualCounts[id]) {
		return 0;
	}

	return (
		manualCounts[id].increment.length - manualCounts[id].decrement.length
	);
};

/**
 * Set increment/decrement manual count for one checkpoint
 * @param {String|Number}  id - CheckpointId
 * @param {Boolean} [increment=true] - Increment by default decrement then.
 */
export const setManualCounts = (id, increment = true) => ({
	type: SET_MANUAL_COUNTS,
	id,
	increment
});

export const fetchCheckpointsBegin = () => ({
	type: FETCH_STATS_CHECKPOINT_BEGIN,
	isLoading: true
});

export const fetchCheckpointsSuccess = data => ({
	type: FETCH_STATS_CHECKPOINT_SUCCESS,
	payload: data,
	isLoading: false
});

export const fetchCheckpointsFailure = error => ({
	type: FETCH_STATS_CHECKPOINT_FAILURE,
	payload: error,
	isLoading: false
});

export const clearStats = () => ({
	type: CLEAR_STATS_CHECKPOINTS
});

export function fetchStatsCheckpoint(
	{ organizationId, checkpointIds },
	signal
) {
	return dispatch => {
		dispatch(fetchCheckpointsBegin());
		return GET(
			`/bo/organizers/${organizationId}/checkpointStats/?id_checkpoints=${checkpointIds}`,
			false,
			signal
		)
			.then(({ data }) => data)
			.then(res => {
				dispatch(fetchCheckpointsSuccess(res));
				return res;
			})
			.catch(error => {
				dispatch(fetchCheckpointsFailure(error));
			});
	};
}
